import React, { useContext } from 'react';
import { RequestEntity } from 'types';
import DishFullInfoControlPanel from './components/DishFullInfoControlPanel/DishFullInfoControlPanel';
import Tabs from './components/Tabs/Tabs';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { DishFullInfoContext, IDishFullInfoContext } from '../../dishFullInfoState/dishFullInfoContext';
import style from './DishFullInfoView.module.scss';

const DishFullInfoView: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div data-test="DishFullInfoView">
			<div className={style.imgWrapper}>
				{dishForFullInfo?.filePath ? (
					<ImgUploaderByEntityId
						resource={RequestEntity.Dishes}
						entityID={dishForFullInfo.id}
						photoSize="Original"
						loaderSize="big"
						noImageIdIcon="menu"
						key="1"
					/>
				) : (
					<ImgUploaderByEntityId
						resource={RequestEntity.Dishes}
						entityID="" // for show noImageIcon
						photoSize="Original"
						loaderSize="big"
						noImageIdIcon="menu"
						key="2"
					/>
				)}
			</div>
			<DishFullInfoControlPanel />
			<Tabs />
		</div>
	);
};

export default DishFullInfoView;
